import Vue from 'vue';
import moment from 'moment-timezone';

export default {
    async getClientCashbackHistory(clientId, start, end) {
        start = moment(start).toISOString();
        end = moment(end).toISOString();
        return (await Vue.http.get(`/api/bonus/client/${clientId}/history/cashback?start=${start}&end=${end}`)).data;
    },
    async getClientPlayThroughHistory(clientId, start, end) {
        start = moment(start).toISOString();
        end = moment(end).toISOString();
        return (await Vue.http.get(`/api/bonus/client/${clientId}/history/playthrough?start=${start}&end=${end}`)).data;
    },
    async getBalanceBonuses(balanceId) {
        return (await Vue.http.get(`/api/bonus/balance/${balanceId}/bonuses`)).data;
    },
    async drop(balanceId, bonusId) {
        return (await Vue.http.post(`/api/bonus/balance/${balanceId}/bonuses/${bonusId}/drop`)).data;
    }
};



// WEBPACK FOOTER //
// ./src/services/bonus.service.js